import { Component, Fragment } from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import HistoryIcon from '@mui/icons-material/History';
import { Box, Button, Grid } from '@mui/material';
import _, { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { withRouter } from 'providers';

import { HistoryListComponent } from 'components/HistoryList';
import ShipmentMessenger from '../ShipmentMessenger';
import AssignmentDetailContainer from './AssignmentDetailContainer';
import AssignmentListMap from './AssignmentListMap';
import DispatchAssignmentListContainer from './DispatchAssignmentListContainer';
import DispatchSearchFilter from './DispatchSearchFilter';
import ShipmentDetailContainer from './ShipmentDetailContainer';
import styles, * as E from './styles';

function AssignmentDetailRoute({
  onShowMessenger,
  showHistoryPanel,
  closePanel,
  isShowAssignmentList,
  history,
  _isActiveAssignmentSelected,
  topicLoading,
  triggerMsgLoading,
  assignmentLoading,
  assignmentId,
}) {
  const selectedAssignmentId = parseInt(assignmentId, 10);

  return (
    <Fragment>
      <Grid sx={{ ...styles.panel, ...styles.assignmentDetailContainer }}>
        <AssignmentDetailContainer onShowMessenger={onShowMessenger} />
      </Grid>
      {isShowAssignmentList ? (
        <Grid sx={{ ...styles.panel, ...styles.shipmentDetailContainer }}>
          {showHistoryPanel ? (
            <Box bgcolor={'primary.white'} height={1} p={2} overflow={'hidden'} boxSizing={'border-box'}>
              <HistoryListComponent baseUrl={`/events/assignments/${selectedAssignmentId}`} type="assignment" closePanel={closePanel} />
            </Box>
          ) : (
            <ShipmentDetailContainer />
          )}
        </Grid>
      ) : (
        <E.PanelMessenger style={{ width: 'calc(100% - 880px)', minWidth: '400px' }}>
          <E.PanelMessengerInner style={styles.box}>
            <ShipmentMessenger
              history={history}
              topicLoading={topicLoading}
              triggerMsgLoading={triggerMsgLoading}
              activeAssignment={_isActiveAssignmentSelected}
              assignmentLoading={assignmentLoading}
            />
          </E.PanelMessengerInner>
        </E.PanelMessenger>
      )}
    </Fragment>
  );
}

class DispatchScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _isShowMessenger: false,
      showHistoryPanel: false,
    };
  }

  componentDidMount() {
    const { store } = this.props;
    const { assignmentStore } = store;

    window.onfocus = () => {
      assignmentStore.onFocus();
    };

    window.onblur = () => {
      assignmentStore.onBlur();
    };
  }

  openPanel = () => {
    this.setState({
      showHistoryPanel: !this.state.showHistoryPanel,
      _isShowMessenger: false,
    });
  };

  closePanel = () => {
    this.setState({ showHistoryPanel: false });
  };

  showAssignmentDetail(a) {
    const { store, history } = this.props;
    const { assignmentStore, shipmentStore } = store;
    const day = moment(assignmentStore.start).format('YYYY-MM-DD');
    const region = assignmentStore.regions.length > 0 ? assignmentStore.regions[0] : 'all';
    if (a) history.push(`/routes/${day}/${region}/${a.id}`);
    else history.push(`/routes/${day}/${region}/`);
    assignmentStore.selectAssignment(a);
    shipmentStore.unselectStop();
  }

  onShowMessenger = () => {
    const { store } = this.props;
    const { messengerStore, assignmentStore, userStore } = store;
    const { selectedAssignmentId } = assignmentStore;
    if (!this.state._isShowMessenger) {
      // Allow open topic when assign to driver
      this.setState({
        topicLoading: true,
        assignmentLoading: true,
      });
      messengerStore.loadTopicByAssignmentId(selectedAssignmentId, (res) => {
        if (res.status === 200) {
          if (userStore.user && messengerStore.topicSelected && messengerStore.topicSelected.follower_ids.indexOf(userStore.user.id) !== -1) {
            messengerStore.isFollow = true;
          } else {
            messengerStore.isFollow = false;
          }
          this.setState({
            topicLoading: false,
            assignmentLoading: false,
          });
        } else if (res.status === 404) {
          this.setState({
            newTopic: true,
            topicLoading: false,
            assignmentLoading: false,
          });
        }
      });
    } else {
      messengerStore.topicSelected = null;
      messengerStore.topicSelectedId = null;
    }
    this.setState({
      showHistoryPanel: false,
      _isShowMessenger: !this.state._isShowMessenger,
    });
  };
  render() {
    const { store, history } = this.props;
    const { assignmentStore } = store;
    const { selectedAssignment } = assignmentStore;
    const _isActiveAssignmentSelected = selectedAssignment?.assignment && selectedAssignment.assignment.is_active;
    const isShowAssignmentList = !this.state._isShowMessenger;
    const isShowAssignmentHistory = !!(selectedAssignment || parseInt(_.get(this.props, 'match.params.assignmentId'), 10));

    return (
      <Box p={1}>
        <Grid container>
          <Grid size="grow">
            <DispatchSearchFilter />
          </Grid>
          <Grid>
            {isShowAssignmentHistory && (
              <Button variant="outlined" size="small" disableElevation onClick={this.openPanel} sx={{ p: 1, minWidth: 50, mr: 1 }}>
                {this.state.showHistoryPanel ? <ClearIcon fontSize={'small'} /> : <HistoryIcon fontSize={'small'} />}
              </Button>
            )}
          </Grid>
        </Grid>
        <Grid container wrap="nowrap" sx={styles.bodyContainer}>
          {(isShowAssignmentList || !this.state.showHistoryPanel) && (
            <Grid sx={{ ...styles.panel, ...styles.assignmentListContainer }}>
              <DispatchAssignmentListContainer />
            </Grid>
          )}
          {this.props.match.params.assignmentId ? (
            <AssignmentDetailRoute
              onShowMessenger={this.onShowMessenger}
              showHistoryPanel={this.state.showHistoryPanel}
              closePanel={this.closePanel}
              isShowAssignmentList={isShowAssignmentList}
              history={history}
              _isActiveAssignmentSelected={_isActiveAssignmentSelected}
              topicLoading={this.state.topicLoading}
              triggerMsgLoading={this.state.triggerMsgLoading}
              assignmentLoading={this.state.assignmentLoading}
              assignmentId={this.props.match.params.assignmentId}
            />
          ) : (
            <Grid size="grow" sx={{ ...styles.panel, ...styles.assignmentMapContainer }}>
              <AssignmentListMap showAssignmentDetail={(assignment, shipmentId) => this.showAssignmentDetail(assignment, shipmentId)} />
            </Grid>
          )}
        </Grid>
      </Box>
    );
  }
}

export default compose(withRouter, inject('store'), observer)(DispatchScreen);
